import { useState, useEffect } from 'react';
import { message } from 'antd';
import { login as userLogin, logout as userLogout, getUserInfo as fetchUserInfo } from '../api/user';
import { setToken, clearToken, setUserInfo, clearUserInfo, isLogin } from '../utils/auth';

export const useAuth = () => {
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfoState] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(isLogin());
  const [initialized, setInitialized] = useState(false);

  // 初始化时检查登录状态
  useEffect(() => {
    if (!initialized && isLogin()) {
      // 如果有token，尝试获取用户信息
      fetchUserInfoData().finally(() => setInitialized(true));
    } else if (!isLogin()) {
      setInitialized(true);
    }
  }, [initialized]);

  // 获取用户信息
  const fetchUserInfoData = async () => {
    try {
      const res = await fetchUserInfo('erp');
      if (res.code === 1) {
        setUserInfo(res.data);
        setUserInfoState(res.data);
        setIsAuthenticated(true);
        return res.data;
      } else {
        throw new Error(res.message || '获取用户信息失败');
      }
    } catch (err) {
      console.error('获取用户信息失败:', err);
      // 如果获取用户信息失败，清除token
      clearToken();
      clearUserInfo();
      setIsAuthenticated(false);
      throw err;
    }
  };

  // 登录
  const login = async (loginForm) => {
    setLoading(true);
    try {
      const res = await userLogin(loginForm);
      if (res.code === 1) {
        const { token } = res.data;
        if (!token) {
          throw new Error('登录失败：未获取到token');
        }
        
        // 保存token
        setToken(token);
        
        // 登录成功后立即获取用户信息
        const userInfo = await fetchUserInfoData();
        
        setInitialized(true);
        message.success('登录成功');
        return res;
      } else {
        throw new Error(res.message || '登录失败');
      }
    } catch (err) {
      clearToken();
      clearUserInfo();
      setIsAuthenticated(false);
      message.error(err.message || '登录失败');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // 退出登录
  const logout = async () => {
    try {
      const res = await userLogout({ appcode: 'erp' });
      if (res.code === 1) {
        clearToken();
        clearUserInfo();
        setUserInfoState(null);
        setIsAuthenticated(false);
        message.success('退出成功');
      } else {
        throw new Error(res.message || '退出失败');
      }
    } catch (err) {
      // 即使退出接口失败，也要清除本地数据
      clearToken();
      clearUserInfo();
      setUserInfoState(null);
      setIsAuthenticated(false);
      message.error(err.message || '退出失败');
    }
  };

  return {
    loading,
    userInfo,
    isAuthenticated,
    initialized,
    login,
    logout,
    fetchUserInfo: fetchUserInfoData
  };
};